module.exports = __webpack_public_path__ + "static/img/homeBgBottom.67dfe21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/homeBgBottom.png
// module id = KOm9
// module chunks = 1